// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as IconStar$Showside from "../icons/IconStar.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function toAbbriviated(countInt) {
  var count = countInt;
  if (count >= 1000000000.0) {
    return (count / 1000000000.0).toFixed(2) + "B";
  } else if (count >= 1000000.0) {
    return (count / 1000000.0).toFixed(2) + "M";
  } else if (count >= 1000.0) {
    return (count / 1000.0).toFixed(2) + "k";
  } else {
    return countInt.toString();
  }
}
function ProductReviews$Summary(Props) {
  var at = Props.at;
  var summary = Props.summary;
  var classNameOpt = Props.className;
  var countClassName = Props.countClassName;
  var largeCountOpt = Props.largeCount;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var largeCount = largeCountOpt !== undefined ? largeCountOpt : false;
  var match = ConfigurationProvider$Showside.use(undefined);
  var transitiveAccount = match.config.transitiveAccount;
  var countEnabled = at ? Belt_Option.mapWithDefault(transitiveAccount, true, function (account) {
    return account.showProductReviewsCountInPLP;
  }) : Belt_Option.mapWithDefault(transitiveAccount, true, function (account) {
    return account.showProductReviewsCountInPDP;
  });
  var showProductReviews = Belt_Option.mapWithDefault(transitiveAccount, true, function (account) {
    return account.showProductReviews;
  });
  var percentage = summary.average / 5.0 * 100.0;
  var style = {
    width: "" + percentage.toString() + "%"
  };
  var renderStars = function (activeOpt) {
    var active = activeOpt !== undefined ? activeOpt : false;
    var className = CSS$Showside.prefix(Cn.make([active ? "text-yellow-400" : "text-primary opacity-10", "w-5 h-5"]));
    return Belt_Array.makeBy(5, function (i) {
      return React.createElement("div", {
        key: String(i),
        className: CSS$Showside.prefix("inline-block")
      }, React.createElement(IconStar$Showside.make, {
        className: className
      }));
    });
  };
  var countClassName$1 = Belt_Option.getWithDefault(countClassName, CSS$Showside.prefix("text-secondary"));
  var match$1 = summary.count;
  var match$2 = summary.average;
  var exit = 0;
  if (match$1 !== 0) {
    exit = 1;
  } else {
    if (match$2 === 0.0) {
      return null;
    }
    exit = 1;
  }
  if (exit === 1) {
    if (!showProductReviews) {
      return null;
    }
    var match$3 = summary.count;
    var tmp;
    var exit$1 = 0;
    if (countEnabled && match$3 !== 0) {
      tmp = React.createElement("div", {
        "aria-label": summary.count.toLocaleString() + " review" + (summary.count === 1 ? "" : "s"),
        className: Cn.make([CSS$Showside.prefix("text-sm"), countClassName$1])
      }, "" + summary.average.toFixed(1) + " (" + toAbbriviated(summary.count) + ")");
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      tmp = React.createElement("div", {
        className: Cn.make([CSS$Showside.prefix("text-sm"), countClassName$1])
      }, summary.average.toFixed(2));
    }
    return React.createElement("div", {
      "aria-label": "user reviews",
      className: Cn.make([CSS$Showside.prefix("flex gap-1"), className, CSS$Showside.prefix(largeCount ? "flex-col items-end" : "items-center flex-wrap")])
    }, React.createElement("div", {
      "aria-label": summary.average.toFixed(1) + " out of 5 stars.",
      className: CSS$Showside.prefix("h-5 relative")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("flex h-full whitespace-nowrap")
    }, renderStars(false)), React.createElement("div", {
      className: CSS$Showside.prefix("flex h-full overflow-hidden absolute whitespace-nowrap top-0"),
      style: style
    }, renderStars(true))), tmp);
  }
}
ProductReviews$Summary.displayName = "ProductReviews.Summary";
var Summary = {
  make: ProductReviews$Summary
};
function ProductReviews(Props) {
  var at = Props.at;
  var product = Props.product;
  var classNameOpt = Props.className;
  var countClassName = Props.countClassName;
  var largeCountOpt = Props.largeCount;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var largeCount = largeCountOpt !== undefined ? largeCountOpt : false;
  ConfigurationProvider$Showside.use(undefined);
  return Belt_Array.keepMap([Belt_Option.map(product.reviewSummary, function (summary) {
    var tmp = {
      at: at,
      summary: summary,
      className: className,
      largeCount: largeCount
    };
    if (countClassName !== undefined) {
      tmp.countClassName = Caml_option.valFromOption(countClassName);
    }
    return React.createElement(ProductReviews$Summary, tmp);
  })], function (a) {
    return a;
  });
}
ProductReviews.displayName = "ProductReviews";
var make = ProductReviews;
export { toAbbriviated, Summary, make };
/* react Not a pure module */